import ToolTip from "components/General/ToolTip"
import { MasteryTypes } from "shared/types/moduleTypes"
import styles from "./styles.module.scss"

interface Props {
    total: number,
    results: { mastery: MasteryTypes, items: string[] }[]
}

export default function MasteryBar({ total, results }: Props ) {
    const masteryMap = {
        'Not Mastered': '#F44336',          // Red
        'Approaches Mastery': '#FF9800',    // Orange
        'Mastered': '#4CAF50',              // Green
        'Exceeds Mastery': '#0000FF'        // Blue
    }

    return (
        <div className="d-flex align-items-center">
            <div className={styles.emptyMasteryBar}>
                {Object.entries(masteryMap).map(([masteryLevel, color]) => {
                    const result = results.find(r => r.mastery === masteryLevel)
                    const width = result ? (result.items.length / total) * 100 : 0
                    
                    return (
                        <ToolTip title={`${masteryLevel}: ${result?.items.length}`} key={result?.mastery + masteryLevel}>
                            <span className={styles.filledMasteryBar} style={{ width: `${width}%`, backgroundColor: color, }} />
                        </ToolTip>
                    )
                })}
            </div>
        </div>
    )
}
